module.exports = "/legacy/43f52450b6035d1763b23a4174891f8c.png";